import { ICItemStatusEntry } from "../declarations/CItemStatusEntry";

/**
 * StatusUpdateTypeID values from the CItemStatus table.
 * Matches the CItemStatusType enum in the monolith
 * (UI/SailDesign/src/System/Enums.ts).
 */
export const STATUS_TYPE = {
    DETAILS_CONFIRMED: 3,
    DESIGN_COMMITTED: 5,
    NESTED: 7,
    TICKET_CHECK_APPROVED: 9,
    COMMIT_TO_MANUFACTURING: 10,
    SCM_PLANNED: 11,
    SCM_ROUTED: 12,
    FINANCE_APPROVED: 13,
    PRODUCTS_COMMITTED: 14,
    ITEMS_COMMITTED: 15,
    ROUTES_COMMITTED: 16,
    BOMS_COMMITTED: 17,
} as const;

export interface IPipelineStep {
    label: string;
    statusTypeID: number;
    readOnly: boolean;
}

/**
 * Pipeline steps in display order.
 * readOnly steps show status but cannot be clicked.
 * Actionable steps can be committed/rolled back.
 */
export const PIPELINE_STEPS: ReadonlyArray<IPipelineStep> = [
    { label: "Finance Approved", statusTypeID: STATUS_TYPE.FINANCE_APPROVED, readOnly: true },
    { label: "Details Confirmed", statusTypeID: STATUS_TYPE.DETAILS_CONFIRMED, readOnly: true },
    { label: "Design Committed", statusTypeID: STATUS_TYPE.DESIGN_COMMITTED, readOnly: true },
    { label: "Nesting Completed", statusTypeID: STATUS_TYPE.NESTED, readOnly: true },
    { label: "Ticket Check Approved", statusTypeID: STATUS_TYPE.TICKET_CHECK_APPROVED, readOnly: true },
    { label: "SCM Planned", statusTypeID: STATUS_TYPE.SCM_PLANNED, readOnly: false },
    { label: "SCM Routed", statusTypeID: STATUS_TYPE.SCM_ROUTED, readOnly: false },
    { label: "Products Committed", statusTypeID: STATUS_TYPE.PRODUCTS_COMMITTED, readOnly: false },
    { label: "Items Committed", statusTypeID: STATUS_TYPE.ITEMS_COMMITTED, readOnly: false },
    { label: "Routes Committed", statusTypeID: STATUS_TYPE.ROUTES_COMMITTED, readOnly: false },
    { label: "BOMs Committed", statusTypeID: STATUS_TYPE.BOMS_COMMITTED, readOnly: false },
    { label: "Commit to Manufacturing", statusTypeID: STATUS_TYPE.COMMIT_TO_MANUFACTURING, readOnly: false },
];

export function getStatusForType(
    statuses: ICItemStatusEntry[],
    statusTypeID: number,
): ICItemStatusEntry | undefined {
    return statuses.find((s) => s.statusUpdateTypeID === statusTypeID);
}

/**
 * Returns the label of the last completed pipeline step,
 * or "Not Started" when no step is complete.
 */
export function getLatestCompletedStepLabel(
    statuses: ICItemStatusEntry[],
): string {
    for (let i = PIPELINE_STEPS.length - 1; i >= 0; i--) {
        const step = PIPELINE_STEPS[i];
        if (getStatusForType(statuses, step.statusTypeID)?.complete === true) {
            return step.label;
        }
    }
    return "Not Started";
}
